import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/contexts/ThemeProvider";

function inputStyles(theme) {
  const base = "w-full font-ui text-[14px] bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background transition-colors";
  switch (theme) {
    case "theme-castlewood":
      return cn(base, "h-11 px-3 rounded-[2px] border border-foreground/40 bg-background");
    case "theme-brionj":
      return cn(base, "h-11 px-3 rounded-none border border-border bg-[hsl(var(--card))]");
    case "theme-vela":
      return cn(base, "h-11 px-3 rounded-[10px] border border-border bg-background");
    case "theme-admin":
      return cn(base, "h-10 px-3 rounded-[8px] border border-border bg-card");
    default:
      return cn(base, "h-11 px-3 rounded-[8px] border border-border bg-background");
  }
}

export const BrandInput = React.forwardRef(({ className, type = "text", ...rest }, ref) => {
  const { theme } = useTheme();
  return <input ref={ref} type={type} className={cn(inputStyles(theme), className)} {...rest} />;
});
BrandInput.displayName = "BrandInput";

export const BrandTextarea = React.forwardRef(({ className, rows = 4, ...rest }, ref) => {
  const { theme } = useTheme();
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(inputStyles(theme), "h-auto py-3", className)}
      {...rest}
    />
  );
});
BrandTextarea.displayName = "BrandTextarea";

export const BrandField = ({ label, htmlFor, children, hint, error, required, className }) => (
  <div className={cn("flex flex-col gap-2", className)}>
    {label && (
      <label htmlFor={htmlFor} className="text-[12px] uppercase tracking-[0.18em] text-muted-foreground font-ui">
        {label}
        {required && <span className="ml-1 text-[hsl(var(--brand-accent))]">*</span>}
      </label>
    )}
    {children}
    {hint && !error && <p className="text-[12px] text-muted-foreground">{hint}</p>}
    {error && <p className="text-[12px] text-[hsl(var(--destructive))]">{error}</p>}
  </div>
);

export default BrandInput;
